export default "__VITE_ASSET__4ORx9AQ5__"